import React, { useState, useEffect, Fragment, useContext } from "react";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import Layout from "components/sales/layout/layout";
import CardSection from "components/sales/cardSection/cardSection";
import { toast } from "react-toastify";

const MarkHandover = ({
  match,
  getChannelPartnerListing,
  channelPartnerListing = [],
  transferHandoverAgainstChannelPartner,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [formData, setFormData] = useState({
    from_channel_partner: null,
    to_channel_partner: null,
  });
  const [modalMessage, setModalMessage] = useState("");
  const [fromChannelPartner, setFromChannelPartner] = useState(null);
  const [toChannelPartner, setToChannelPartner] = useState(null);

  const handleInputChange = (value, key) => {
    setFormData({ ...formData, [key]: value });
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getChannelPartnerListing();
      setIsLoading(false);
    })();
  }, [getChannelPartnerListing]);

  const handleSubmit = async () => {
    if (
      (formData && formData.from_channel_partner == "") ||
      formData.from_channel_partner == null ||
      formData.from_channel_partner == undefined
    ) {
      toast.error("From Channel Partner is required");
      return;
    }
    if (
      (formData && formData.to_channel_partner == "") ||
      formData.to_channel_partner == null ||
      formData.to_channel_partner == undefined
    ) {
      toast.error("To Channel Partner is required");
      return;
    }
    if (
      formData &&
      formData.from_channel_partner == formData.to_channel_partner
    ) {
      toast.error("From Channel Partner and To Channel Partner cannot be same");
      return;
    }
    setIsLoading(true);
    const res = await transferHandoverAgainstChannelPartner(formData);
    setIsLoading(false);
    if (res?.status == 0) {
      setModalMessage(res?.data?.total_updated_contracts);
      setIsModal(true);
    } else {
      toast.error(res?.message || "Something went wrong");
    }
  };

  const handleModalHide = () => {
    setIsModal(false);
    setFormData({
      from_channel_partner: null,
      to_channel_partner: null,
    });
    window.location.reload();
  };

  return (
    <Layout title={"Transfer Handover"} isLoading={isLoading}>
      <CardSection title={"Transfer Handover"}>
        {/* Dropdown Row */}
        <div className="row">
          <div className="col-md-6">
            <h4 style={{ marginBottom: "15px" }}>Handover Contracts From</h4>
            <DropDownInput
              data={channelPartnerListing?.data}
              label={"Channel Partner Name"}
              required
              errorMsg={"Channel Partner Name is required"}
              isStarRequired
              getIdValue={(val) => {
                const id = typeof val === "object" ? val.id : val;
                const partner = channelPartnerListing?.data?.find(
                  (item) => item.id == id
                );
                handleInputChange(id, "from_channel_partner");
                setFromChannelPartner(partner ? partner.name : "");
              }}
            />
          </div>

          <div className="col-md-6">
            <h4 style={{ marginBottom: "15px" }}>Handover Contracts To</h4>
            <DropDownInput
              data={channelPartnerListing?.data}
              label={"Channel Partner Name"}
              required
              errorMsg={"Channel Partner Name is required"}
              isStarRequired
              getIdValue={(val) => {
                const id = typeof val === "object" ? val.id : val;
                const partner = channelPartnerListing?.data?.find(
                  (item) => item.id == id
                );
                handleInputChange(id, "to_channel_partner");
                setToChannelPartner(partner ? partner.name : "");
              }}
            />
          </div>
          <div className="col-md-4">
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={
                isLoading ||
                !formData?.from_channel_partner ||
                !formData?.to_channel_partner
              }
            >
              Submit
            </Button>
          </div>
        </div>
      </CardSection>

      <ModalPop title="" show={isModal} handleModalHide={handleModalHide}>
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>
            {modalMessage} contracts handed over successfully from{" "}
            {fromChannelPartner} to {toChannelPartner}
          </h5>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default MarkHandover;
